import * as React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div<{ $color: string; $isDragActive: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${props => (props.$isDragActive ? 6 : 3)};
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: clamp(10px, 3vw, 18px);
  background: ${props => (props.$isDragActive ? `linear-gradient(180deg, rgba(2, 6, 23, 0.42) 0%, ${props.$color} 100%)` : 'transparent')};
  backdrop-filter: ${props => (props.$isDragActive ? 'blur(14px)' : 'none')};
  overflow: hidden;
`

const Input = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`

const Content = styled.div`
  width: 100%;
  min-height: 0;
  display: flex;
  overflow: auto;
  overscroll-behavior: contain;
`

const DragOverlay = styled.div`
  width: min(480px, 100%);
  max-height: calc(100dvh - 36px);
  margin: auto;
  padding: 24px;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 22px;
  background: rgba(15, 23, 42, 0.78);
  box-shadow: 0 18px 48px rgba(2, 6, 23, 0.28);
  overflow: auto;
  text-align: center;
`

const DragTitle = styled.div`
  font-size: clamp(1.5rem, 4vw, 2.2rem);
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0;
  color: #f8fafc;
`

const DragDescription = styled.div`
  margin-top: 10px;
  font-size: 0.92rem;
  line-height: 1.6;
  color: rgba(226, 232, 240, 0.72);
`

type Props = {
  isDragActive: boolean
  backgroundColor: string
  inputProps: React.InputHTMLAttributes<HTMLInputElement>
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  children: React.ReactNode
}

export const Dropzone = (props: Props) => {
  const transparentColor = React.useMemo(() => {
    const r = parseInt(props.backgroundColor.substring(1, 3), 16)
    const g = parseInt(props.backgroundColor.substring(3, 5), 16)
    const b = parseInt(props.backgroundColor.substring(5, 7), 16)

    return `rgba(${r}, ${g}, ${b}, 0.58)`
  }, [props.backgroundColor])

  return (
    <Wrapper $color={transparentColor} $isDragActive={props.isDragActive} onClick={props.onClick}>
      <Input {...props.inputProps} />

      {props.isDragActive ? (
        <DragOverlay>
          <DragTitle>{props.children}</DragTitle>
          <DragDescription>Release to open the model.</DragDescription>
        </DragOverlay>
      ) : (
        <Content>{props.children}</Content>
      )}
    </Wrapper>
  )
}
